module.exports = "<corporate-contract-approvals-page></corporate-contract-approvals-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/corporateContractApprovals.html
// module id = 2247
// module chunks = 0